module.exports = __webpack_public_path__ + "img/page3.6509690c.png";